<template>
  <f7-page
    no-toolbar
    no-swipeback
    name="integral-records"
    class="page-integral-records"
    infinite
    :infinite-distance="50"
    :infinite-preloader="showPreloader"
    @infinite="loadMore"
  >
    <f7-navbar :title="$t('member_center_0031')" back-link :no-hariline="true"></f7-navbar>
    <f7-block class="block-records" v-if="integralRecordsList.length>0">
      <div class="card card-outline" v-for="item in integralRecordsList" :key="item.BonusPointEventID">
        <div class="card-header">
          <div class="card-meta">
            <div class="meta-item">
              <div class="font14">No.{{item.BonusPointEventID}}</div>
              <div class="meta-value meta-value-type co-gray">{{ getBonusPointBatchTypeText(item.BonusPointBatchType) }}</div>
            </div>
          </div>
        </div>
        <div class="card-content card-content-padding">
          <div class="record-summary">
            <div class="summary-item summary-item-left">
              <div class="summary-label">{{ $t('integral_records_0011') }}</div>
              <div
                class="summary-value" :class="item.DiffCurrentBonusPoint>0?'co-green':'co-yellow'"
              >{{item.DiffCurrentBonusPoint| formatCurrency2}}</div>
            </div>
            <div class="summary-item summary-item-right">
              <div class="summary-label">{{ $t('integral_records_0010') }}</div>
              <div class="summary-value co-blue">{{item.BeforeCurrentBonusPoint | formatCurrency2}}</div>
            </div>
          </div>
        </div>
        <div class="card-footer co-white">{{item.CreateTS|time}}</div>
      </div>
    </f7-block>

    <f7-card v-else-if="integralRecordsList.length<=0 && !showData" class="no-data">
      <img :src="`../../../static/images/yt999/noData_${ $f7.params.currLang }.png`" width="45%" :onerror="`this.onerror=''; src='../../../static/images/yt999/noData_enUS.png'`" alt="No data" >
    </f7-card>
  </f7-page>
</template>

<script>
import { getIntegralRecordsList } from "../../../axios/api";
export default {
  components: {},
  props: {},
  data() {
    return {
      integralRecordsList: [],
      allowInfinite: true,
      showPreloader: true,
      pageNow: 1,
      pageTotal: 0,
      showData: true,
    };
  },
  watch: {},
  computed: {},
  methods: {
    getBonusPointBatchTypeText(batchType) {
      const translationMap = {
        OfflineDeposit: 'integral_records_0004',
        OnlineDeposit: 'integral_records_0005',
        ManualDeposit: 'integral_records_0006',
        BetTicketInit: 'integral_records_0007',
        BetTicketUpdate: 'integral_records_0008',
        BonusPointConsume: 'integral_records_0009',
        ManualAddBonusPoint: 'integral_records_0012',
        ManualSubtractBonusPoint: 'integral_records_0013',
        BonusPointRefund: 'integral_records_0014',
        LuckyDraw: 'integral_records_0015',
        WhenHaveNewSubMemberRegisterThenUpdateBonusPoint: 'integral_records_0016',
        WhenHaveNewSubMemberFirstTimeActiveVIPThenUpdateBonusPoint: 'integral_records_0017',
        WhenMemberFirstTimeActiveVIPThenUpdateBonusPoint: 'integral_records_0018',
        WhenMemberUpgradeVIPThenUpdateBonusPoint: 'integral_records_0019'
      };
      return translationMap[batchType] ? this.$t(translationMap[batchType]) : batchType;
    },
    integralRecordsListEvent() {
      const self = this;
      let queryParam = JSON.parse(self.$f7route.params.Info);
      queryParam.BeginDate = Math.round(
        new Date(queryParam.BeginDate.replace(/-/g,'/')).getTime() / 1000
      );
      queryParam.EndDate = Math.round(
        new Date(queryParam.EndDate.replace(/-/g,'/')).getTime() / 1000
      );
      queryParam.PageNow = self.pageNow;
      queryParam.PageSize = 20;
      queryParam.Category = 0;

      const params = { data: JSON.stringify(queryParam) };
      getIntegralRecordsList(params).then(data => {
        if (data.Code === "NoError") {
          self.integralRecordsList = self.integralRecordsList.concat(
            data.Data.Data
          );
          self.showData = self.integralRecordsList.length > 0;
          self.pageTotal = data.Data.Total;
          if (self.integralRecordsList.length >= self.pageTotal) {
            self.showPreloader = false;
          }
        }
      });
    },
    loadMore() {
      const self = this;
      if (!self.allowInfinite) return;
      self.allowInfinite = false;

      setTimeout(() => {
        if (self.integralRecordsList.length >= self.pageTotal) {
          self.showPreloader = false;
          return;
        }
        self.pageNow += 1;
        self.integralRecordsListEvent();
        self.allowInfinite = true;
      }, 1000);
    }
  },
  created() {
    this.integralRecordsListEvent();
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.page-integral-records {
  background: #f5f6fb;

  .block-records {
    margin: 0;
    padding: 8px 8px 16px;

    .card {
      border: 0;
      background: #ffffff;
      margin: 0 0 12px;
      border-radius: 13px;
      box-shadow: 0 6px 18px rgba(25, 42, 70, 0.08);
      overflow: hidden;

      .co-white {
        color: #3f4758;
      }

      .co-gray {
        color: #566074;
      }

      .co-green {
        color: #19a55a;
      }

      .co-blue {
        color: var(--f7-THEME-color);
      }

      .co-yellow {
        color: #f59b14;
      }

      .co-red {
        color: #c50d0d;
      }

      .card-header:after,
      .card-footer:before {
        display: none;
      }

      .card-header {
        display: block;
        padding: 18px 18px 10px;
        min-height: auto;

        .card-meta {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 12px;
        }

        .meta-item {
          flex: 1;
          min-width: 0;
          .font14{
            font-size: 14px;
          }
        }

        .meta-item-right {
          text-align: right;
        }

        .meta-label {
          font-size: 12px;
          line-height: 1.2;
          color: #7f8796;
          margin-bottom: 8px;
        }

        .meta-value {
          font-size: 17px;
          line-height: 1.35;
          font-weight: 700;
          color: #2f3747;
          word-break: break-word;
        }

        .meta-value-id {
          letter-spacing: 0.2px;
        }

        .meta-value-type {
          font-size: 14px;
        }
      }

      .card-content {
        font-size: 15px;
        padding: 0 18px 14px;

        .record-summary {
          display: flex;
          background: linear-gradient(180deg, #f5f6f8 0%, #eef1f5 100%);
          border-radius: 12px;
          overflow: hidden;
        }

        .summary-item {
          flex: 1;
          padding: 14px 16px 16px;
          min-width: 0;
        }

        // .summary-item-right {
        //   border-left: 1px solid #dde2ea;
        //   text-align: right;
        // }

        .summary-item-right {
          position: relative;
          text-align: right;
        }

        .summary-item-right::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          height: 40px; /* 你想要的高度 */
          border-left: 1px solid #dde2ea;
        }

        .summary-label {
          font-size: 12px;
          line-height: 1.2;
          color: #7f8796;
          margin-bottom: 8px;
        }

        .summary-value {
          font-size: 20px;
          line-height: 1.2;
          font-weight: 700;
          word-break: break-word;
        }
      }

      .card-footer {
        justify-content: flex-end;
        padding: 2px 18px 18px;
        font-size: 12px;
        line-height: 1.2;
        color: #9098a8;
      }
    }
  }

  .no-data {
    background-color: transparent;
    box-shadow: none;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    height: 50%;
  }
}
</style>